import React from 'react';
import Loader from '../zak_component/Loader';
import { Navigate } from 'react-router-dom';
import { UserAuth } from '../Firebase/authcontext';

const Protected = ({ children }) => {
  const { user,apploading } = UserAuth();
  if (apploading) {
    return <div style={{display: "flex",justifyContent: "center",alignItems: "center",height: "100vh" }}><Loader/></div>;

  }

  if (!user) {
    return <Navigate to='/' />;
  }

  return children;
};

export default Protected;